/* GEHNA — Amazon-style product lightbox (one image at a time + thumbnails). */
if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.gxIndex = 0;
        this.gxReady = false;
      }

      hide() {
        this.gxPauseAll();
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.gxSetup();
        this.showActiveMedia();
      }

      gxSetup() {
        if (this.gxReady) return;
        this.gxReady = true;
        this.gxSlides = Array.from(this.querySelectorAll('.gx-lb__slide'));
        this.gxThumbs = Array.from(this.querySelectorAll('.gx-lb__thumb'));
        this.gxCount = this.querySelector('.gx-lb__count');

        this.gxThumbs.forEach((thumb, i) => thumb.addEventListener('click', () => this.gxGo(i)));
        const prev = this.querySelector('.gx-lb__prev');
        const next = this.querySelector('.gx-lb__next');
        if (prev) prev.addEventListener('click', () => this.gxGo(this.gxIndex - 1));
        if (next) next.addEventListener('click', () => this.gxGo(this.gxIndex + 1));

        this.addEventListener('keydown', (e) => {
          if (!this.hasAttribute('open')) return;
          if (e.key === 'ArrowRight') { e.preventDefault(); this.gxGo(this.gxIndex + 1); }
          if (e.key === 'ArrowLeft') { e.preventDefault(); this.gxGo(this.gxIndex - 1); }
        });

        // close only when clicking the dark backdrop (not arrows / thumbs / image)
        const dialog = this.querySelector('.product-media-modal__dialog');
        if (dialog) dialog.addEventListener('click', (e) => { if (e.target === dialog) this.hide(); });

        const stage = this.querySelector('.gx-lb__stage');
        if (stage) {
          let startX = null;
          stage.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; }, { passive: true });
          stage.addEventListener('touchend', (e) => {
            if (startX === null) return;
            const dx = e.changedTouches[0].clientX - startX;
            if (Math.abs(dx) > 40) this.gxGo(this.gxIndex + (dx < 0 ? 1 : -1));
            startX = null;
          });
        }
      }

      showActiveMedia() {
        const id = this.openedBy ? this.openedBy.getAttribute('data-media-id') : null;
        let index = this.gxSlides.findIndex((s) => s.dataset.gxMedia === String(id));
        if (index < 0) index = 0;
        this.gxGo(index);
      }

      gxPauseAll() {
        (this.gxSlides || []).forEach((slide) => {
          slide.querySelectorAll('video').forEach((v) => v.pause());
          slide.querySelectorAll('.js-youtube').forEach((f) => f.contentWindow && f.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*'));
          slide.querySelectorAll('.js-vimeo').forEach((f) => f.contentWindow && f.contentWindow.postMessage('{"method":"pause"}', '*'));
        });
      }

      gxGo(i) {
        const total = this.gxSlides.length;
        if (!total) return;
        this.gxPauseAll();
        this.gxIndex = (i + total) % total;
        this.gxSlides.forEach((s, n) => s.classList.toggle('is-active', n === this.gxIndex));
        this.gxThumbs.forEach((t, n) => {
          const on = n === this.gxIndex;
          t.setAttribute('aria-current', on ? 'true' : 'false');
          if (on) t.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        });
        if (this.gxCount) this.gxCount.textContent = `${this.gxIndex + 1} / ${total}`;
      }
    }
  );
}
